import { apiSlice } from "../../apiSlice";

/**
 * Slice para el dashboard de Facturas sin DO Asociado
 */
export const invsindoApiSlice = apiSlice.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    getDataGraphicFacturasSinDo: builder.query({
      query: () => ({
        url: "/Faccomxx/Graphics/InvoicesWithoutDo",
        method: "GET",
        headers: { Modulecima: "faccomxx" },
      }),
    }),
  }),
});

export const { useGetDataGraphicFacturasSinDoQuery } = invsindoApiSlice;
